import { Eye, EyeOff } from "lucide-react";
import { useContent } from "@/lib/content";

// Section wrapper that can be hidden from the live site (metadata.hidden under key `k`).
export const Section = ({ k, label, className = "", children, ...rest }) => {
  const { editMode, get, stage } = useContent();
  const hidden = !!get(k)?.metadata?.hidden;

  if (!editMode) return hidden ? null : <section className={className} {...rest}>{children}</section>;

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    stage(k, { content: "", metadata: { hidden: !hidden } });
  };

  return (
    <section className={`${className} relative live-section ${hidden ? "live-section-hidden" : ""}`} data-live-section={k} {...rest}>
      <button type="button" onClick={toggle} data-testid={`live-section-toggle-${k}`} aria-pressed={hidden}
        className={`absolute top-3 right-3 z-30 inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-body text-[11px] tracking-widest uppercase shadow-lg transition-colors ${hidden ? "bg-lipstick-red text-white" : "bg-charcoal/85 text-ivory hover:bg-charcoal"}`}>
        {hidden ? <><EyeOff className="w-3.5 h-3.5" /> Hidden — click to show</> : <><Eye className="w-3.5 h-3.5" /> {label ? `Hide ${label}` : "Hide section"}</>}
      </button>
      {children}
    </section>
  );
};
